export const LOCATIONS = 'locations'
export const SET_LOCATIONS = LOCATIONS + '/SET_LOCATIONS'
export const SET_CURRENT_LOCATION = LOCATIONS + '/SET_CURRENT_LOCATION'
